import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import i18next from 'i18next';

import { DEFAULT_LANGUAGE } from 'config';

const detectionOptions = {
  order: ['localStorage', 'navigator'],
  caches: ['localStorage'],
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    ns: 'common',
    load: 'languageOnly',
    detection: detectionOptions,
    fallbackLng: DEFAULT_LANGUAGE,
    debug: false,
    backend: {
      allowMultiLoading: false,
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      addPath: '/locales/{{lng}}/{{ns}}.json',
      crossDomain: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18next;
